import { useLocation } from 'react-router-dom';

import { DocumentTitle } from '@/components/document-title';
import { useRealmProfile } from '@/realm-profile/context';
import { useRealmBrand } from '@/realm-profile/profile';
import { RealmProfileRenderer } from '@/realm-profile/renderer';

import './official-home.css';
import { usePublicPageHashAnchor, usePublicPageViewport } from './use-public-page-viewport';

/** OfficialHomePage 在原 tenant-web 首页路由中渲染当前渠道发布的 JSON Schema。 */
export default function OfficialHomePage() {
  usePublicPageViewport();
  const { hash, key } = useLocation();
  const { loading, profile, retry, source } = useRealmProfile();
  // Router 的 history 写入不会触发 hashchange，并且相同 hash 的重复导航只能通过 location.key 区分。
  usePublicPageHashAnchor(loading ? undefined : profile?.contentHash, hash, key);
  const brand = useRealmBrand();
  return (
    <>
      <DocumentTitle suffix={brand.title} />
      <RealmProfileRenderer
        loading={loading}
        profile={profile}
        source={source}
        onRetry={retry}
      />
    </>
  );
}
